import React, { useEffect, useState } from "react";
import { db } from "../../firebase/config";
import {
  collection,
  addDoc,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import Swal from 'sweetalert2';
import MicIcon from '@mui/icons-material/Mic';

import Header from './Header';
import { Sugerencias } from '../../Utils/Sugerencias';
import FormTienda from './formTienda';



export const FormularioTienda = ( ) => {
   /*const [nombre, setNombre] = useState("");
    const [talles, setTalles] = useState("");
    const [precio, setPrecio] = useState(0);
    const [stock, setStock] = useState(0);
   
    const [descripcion, setDescripcion] = useState("");
    const [items, setItems] = useState([]);*/

 
  return (
    <div className="form-background">
     <Header/>
    <FormTienda/>

           
    </div>
  );
  
}

export default FormularioTienda;

